import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function create(data) {
  const response = await http
    .postData("/suket-sehat-jasmani", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function update(id: number, data) {
  const response = await http
    .putData(`/suket-sehat-jasmani/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/suket-sehat-jasmani`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function find(id: number) {
  const response = await http
    .getData(`/suket-sehat-jasmani/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/suket-sehat-jasmani/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function sign(id: number, data) {
  const response = await http
    .postData(`/suket-sehat-jasmani/${id}/signature`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

function print(id) {
  window.open(`${http.getAPI()}/suket-sehat-jasmani/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy,
  sign,
  print
};
